import { Controller } from '@hotwired/stimulus';

/* global $ */
export default class extends Controller {
  connect() {
    const $element = $(this.element);
    this.$selectorProfesor = $element.find('[name="filtro_registros[profesor_id]"]');
    this.$selectorEstructura = $element.find('#selector-estructura .selector-estructura-wrapper');
    this.reseteando = false;
    this.limpiandoSelector = false;

    this.$selectorProfesor.on('change', () => {
      if (!this.reseteando) {
        this.limpiandoSelector = true;
        this.$selectorEstructura[0].dispatchEvent(
          new CustomEvent(
            'limpiar-seleccion', { bubbles: false },
          ),
        );
      }
    });

    this.#gestionarSelector();
  }

  #gestionarSelector() {
    this.$selectorEstructura.on('change', (e) => {
      if (this.limpiandoSelector) {
        this.limpiandoSelector = false;
        return;
      }

      this.reseteando = true;
      this.$selectorProfesor.val('');
      this.$selectorProfesor.trigger('change');
      this.reseteando = false;
    });

    this.selectorEstructuraConectado = true;
  }
}
